// Real auth against the Morpheus Auth Gateway (146). Token in localStorage.
const API = "https://api.morpheus.maatz.studio";
const TOKEN_KEY = "morpheus_token";
const USER_KEY = "morpheus_user";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null");
  } catch {
    return null;
  }
}

export function isAuthed() {
  return !!getToken();
}

export async function login(email, password) {
  const res = await fetch(`${API}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    let msg = "Login fehlgeschlagen";
    try {
      const j = await res.json();
      msg = j.detail || msg;
    } catch (e) { /* ignore */ }
    throw new Error(msg);
  }
  const data = await res.json();
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(USER_KEY, JSON.stringify(data.user || {}));
  return data.user;
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.location.reload();
}
